import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BuyappComponent } from '../buyapp/buyapp.component';
import { AlertInfo } from 'src/app/core/enums/alert-info';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  standalone: false,
  selector: 'app-buy-app-alert',
  templateUrl: './buy-app-alert.component.html',
  styleUrls: ['./buy-app-alert.component.scss']
})
export class BuyAppAlertComponent implements OnInit {
  @Output() emitCloseRef = new EventEmitter();
  @Input() appData: any;
  @Input() type = '';
  @Input() trailInfo = '';
  @Input() currentUser: any;

  appcode: any;
  closeResult: string = '';
  modalReference: any;
  submitted: boolean = false;


  constructor(
    private router: Router,
    // public commonService: CommonService,
    private modalService: NgbModal,
    private alertService: AlertService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.appcode = this.appData?.appCode;
  }


  buyApp() {
    debugger
    if (this.currentUser?.mainRole == 'Mentor') {
      this.alertService.showMessage(AlertInfo.WARNING, 'As a mentor, you are not able to subscribe to the app directly.Please contact your administration to arrange a subscription.');
    }
    else {
      this.activeModal.close('Close click');
      this.modalReference = this.modalService.open(BuyappComponent, {
        size: 'md',
        keyboard: false,
        backdrop: "static",
        centered: true
      });
      this.modalReference.componentInstance.appData = this.appData;
      this.modalReference.componentInstance.currentUser = this.currentUser;
      this.modalReference.result.then((result: any) => {
        if (result == 'Cross click') {
          // this.commonService.getAppConfig(false, true, true);
        }
      });
    }


  }

  goTpApps() {
    this.router.navigate(['apps']);
    this.activeModal.close('Close click');
  }

  createForm() {
    throw new Error('Method not implemented.');
  }
  IssueCreateForm() {
    throw new Error('Method not implemented.');
  }

  // refClose() {
  //   this.emitCloseRef.next();
  // }
}
